import React, { Component } from 'react'

import Breadcrumb from '../../components/Breadcrumb/'

import { Wrap, Tabs, Tab, Filler, BreadContainer } from './styles'

class TabBreadcrumb extends Component {

  constructor(props) {
    super(props)
    this.state = {
      activeOne: true,
      activeTwo: false
    }
  }

  handleClickOne(e) {
    this.setState({ 
      activeOne: true,
      activeTwo: false
    })
    this.props.onClickOne(e)
  }

  handleClickTwo(e) {
    this.setState({ 
      activeOne: false,
      activeTwo: true
    })
    this.props.onClickTwo(e)
  }

  render() {
    const { parent, parentUrl, title, one, oneShort, two, twoShort } = this.props
    const { activeOne, activeTwo } = this.state

    return (
      <Wrap>

        <Filler></Filler>
        
        <Tabs>
          <Tab onClick={this.handleClickOne.bind(this)} active={activeOne}>
            <span>{one}</span>
            <span>{oneShort}</span>
          </Tab>
          <Tab onClick={this.handleClickTwo.bind(this)} active={activeTwo}>
            <span>{two}</span>
            <span>{twoShort}</span>
          </Tab>
        </Tabs>

        <BreadContainer>
          <Breadcrumb title={title} parent={parent} parentUrl={parentUrl} />
        </BreadContainer>

      </Wrap>
    )
  }
}

export default TabBreadcrumb


// WEBPACK FOOTER //
// ./src/components/TabBreadcrumb/index.js